import { useSelector } from "react-redux";
import { Polyline, Popup } from "react-leaflet";

/**
 * Page Section
 */
function RoadStretchMarkers() {
  // Added Stretches
  const selectedStretchIds = useSelector((state) =>
    Object.keys(state.roadStretchesSelection.selectedStretchesMapView)
  );

  // total stretches of city
  const orgRoadStretches = useSelector(
    (state) => state.orgRoadStretch.orgRoadStretches
  );

  // selected stretches to show on map
  const selectedStretchesForMap = selectedStretchIds.reduce(
    (acc, stretchId) => {
      acc.push(orgRoadStretches[stretchId]);
      return acc;
    },
    []
  );

  // Style stretch
  const stretchStyle = {
    weight: 10,
    color: "blue",
    opacity: 1,
  };

  return (
    <>
      {selectedStretchesForMap.map((eachStretch) => {
        const { id, name } = eachStretch || {};
        const trace = eachStretch?.trace || [];
        return (
          <Polyline key={id} pathOptions={stretchStyle} positions={trace}>
            <Popup>
              <b className="d-block">{name}</b>
            </Popup>
          </Polyline>
        );
      })}
    </>
  );
}

export default RoadStretchMarkers;
